/* src/app/components/welcome/welcome.component.scss */
.btn-success {
  display: inline-block;
  background: none;
  color: #40c706;
  border-color: currentColor;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  text-transform: uppercase;
  vertical-align: middle;
  cursor: pointer;
  border-width: 1px;
}
.btn-success:hover,
.btn-success:focus,
.btn-success:active,
.btn-success:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #7ac138;
  background: #40c706;
}
/*# sourceMappingURL=welcome.component.css.map */
